/**
 * Tech Depot India — subtle UI depth layer (idle-loaded)
 */
(function () {
  'use strict';

  function init() {
    var fine = window.matchMedia('(pointer: fine)').matches;
    var mobile = window.matchMedia('(max-width:768px)').matches;

    if (!mobile) {
      var orbs = document.createElement('div');
      orbs.className = 'td-orbs';
      orbs.innerHTML =
        '<div class="td-orb td-orb-1"></div>' +
        (fine ? '<div class="td-orb td-orb-2"></div><div class="td-orb td-orb-3"></div>' : '');
      document.body.prepend(orbs);
    }

    var nav = document.querySelector('.site-header') || document.querySelector('nav');
    if (nav) {
      var scrolled = false;
      window.addEventListener('scroll', function () {
        var s = window.scrollY > 60;
        if (s !== scrolled) {
          scrolled = s;
          nav.classList.toggle('is-scrolled', s);
          nav.classList.toggle('td-nav-scrolled', s);
        }
      }, { passive: true });
    }

    if (fine) {
      document.querySelectorAll('.btn-primary, .btn-secondary, .cta-pill').forEach(function (btn) {
        btn.addEventListener('mousemove', function (e) {
          var r = btn.getBoundingClientRect();
          btn.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.15) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.15) + 'px)';
        });
        btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
      });
    }
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(init, { timeout: 2000 });
  } else {
    window.addEventListener('load', function () { setTimeout(init, 200); });
  }
})();
